import * as Types from 'types'

export default function checkIfRootCauseNeglectOrDefect(value) {
  return (
    Types.ROOT_CAUSE_NEGLECT_OPTIONS.includes(value) ||
    value == Types.ROOT_CAUSE_DEFECT
  )
}
